import getEnvironmentVariables from '@/config/environment';
import { isServer } from '@/helpers/isServer';

interface HeapClientConfig {
  shouldFetchServerConfig?: boolean;
}

interface Heap {
  envId?: string;
  clientConfig?: HeapClientConfig;
  [key: string]: any;
}
declare global {
  interface Window {
    heapReadyCb: Array<{ name: string; fn: Function }>;
    heap: Heap;
  }
}

export const heap = () => {
  const { ENABLE_HEAP, HEAP_APP_ID } = getEnvironmentVariables() || {};

  if (!ENABLE_HEAP || isServer()) {
    return;
  }

  window.heapReadyCb = window.heapReadyCb || [];
  window.heap = window.heap || [];

  window.heap.load = (envId: string, clientConfig?: HeapClientConfig) => {
    window.heap.envId = envId;
    window.heap.clientConfig = clientConfig || {};
    window.heap.clientConfig.shouldFetchServerConfig = false;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://cdn.us.heap-api.com/config/${envId}/heap_config.js`;

    const head = document.getElementsByTagName('head')[0];
    head.appendChild(script);

    const methods = [
      'init',
      'startTracking',
      'stopTracking',
      'track',
      'resetIdentity',
      'identify',
      'getSessionId',
      'getUserId',
      'getIdentity',
      'addUserProperties',
      'addEventProperties',
      'removeEventProperty',
      'clearEventProperties',
      'addAccountProperties',
      'addAdapter',
      'addTransformer',
      'addTransformerFn',
      'onReady',
      'addPageviewProperties',
      'removePageviewProperty',
      'clearPageviewProperties',
      'trackPageview'
    ];
    /* istanbul ignore next */
    const createMethod = (methodName: string) => {
      return function (...args: any[]) {
        window.heapReadyCb.push({
          name: methodName,
          fn: () => {
            if (window.heap[methodName]) {
              window.heap[methodName].apply(window.heap, args);
            }
          }
        });
      };
    };

    methods.forEach(method => {
      window.heap[method] = createMethod(method);
    });
  };

  if (HEAP_APP_ID) {
    window.heap.load(HEAP_APP_ID);
  }
};
